import { Invitation, Notification } from '../contract';

// How marking notifications read turns the cached list into its next version: a new object, the original untouched, with
// no React or network in it, so it can be tested directly. data/notifications.ts applies it to the cache.

export type NotificationList = { invitations: Invitation[], notifications: Notification[], unreadCount: number };

// Marks the named notifications in the list read (all of them when no ids are given), and takes the unread count the
// server reported afterwards (it counts notifications beyond the few listed). Ones already read keep the time they were
// read. With no list cached there is nothing to patch.
export const withRead = (list: NotificationList | undefined, ids: string[] | undefined, readAt: string, unreadCount: number): NotificationList | undefined =>
    list && {
        ...list,
        unreadCount,
        notifications: list.notifications.map((n) => (!n.readAt && (!ids || ids.includes(n.id)) ? { ...n, readAt } : n)),
    };

// An invitation that has been answered no longer waits for an answer.
export const withoutInvitation = (list: NotificationList | undefined, invitationId: string): NotificationList | undefined =>
    list && { ...list, invitations: list.invitations.filter((invitation) => invitation.id !== invitationId) };
